<template>
<messaging-bar class="topbar">
  <div class="info">
    <a @click.prevent="onOpenConversations" class="conversation-icon is-hidden-tablet">
      <img src="@/assets/contact-list-white.svg" width="32" />
    </a>
    <div @click="gotoProfile" class="user-image">
      <user-image :user="currentUser" :state="activeState" class="is-40x40" />
    </div>
    <div class="text-info" v-if="currentUser">
      <a @click="gotoProfile"><strong>{{ name }}</strong></a>
<!--      <span v-if="status && status.lastActive">Last active: {{ timeFromNow }}</span>-->
    </div>
  </div>
  <div v-if="false">
    <dropdown :is-right='true' :is-active.sync="dropdownActive">
      <button class="button" :class="{'is-active': dropdownActive }"
        @click="toggleActive">
        ••
      </button>
      <template slot="dropdown-content">
        <a class="dropdown-item" @click.prevent="editProfileClicked">
          Edit Profile
        </a>
        <hr class="dropdown-divider">
        <a class="dropdown-item" @click.prevent="logoutClicked">
          Logout
        </a>
      </template>
    </dropdown>
  </div>
</messaging-bar>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Dropdown from '@/components/general/dropdown'
import MessagingBar from '@/components/messaging/messaging-bar'
import UserImage from '@/components/general/user-image'

export default {
  components: { Dropdown, MessagingBar, UserImage },
  props: {
    conversation: {
      type: Object,
      default: () => null
    },
    user: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    user () {
      this.setCurrentStatus(null)
      this.getUserStatus()
      this.getTimeFromNow()
    },
    conversation () {
      this.setCurrentStatus(null)
      this.getUserStatus()
    },
    status () {
      this.getTimeFromNow()
    }
  },
  computed: {
    ...mapGetters('conversations', [
      'otherUser'
    ]),
    ...mapState('conversations', {
      status: 'currentStatus'
    }),
    currentUser () {
      const conv = this.conversation
      if (conv) {
        return this.otherUser(conv)
      } else {
        return this.user
      }
    },
    name () {
      const user = this.currentUser
      if (!user) { return '' }
      return `${user.firstName} ${user.lastName}`
    },
    activeState () {
      const status = this.status
      if (!status || !status.isConnected) { return 'offline' }
      if (moment(status.lastActive).add(5, 'minutes').isBefore(new Date())) {
        return 'inactive'
      }
      return 'active'
    }
  },
  methods: {
    ...mapActions('conversations', {
      getStatusForUser: 'getUserStatus'
    }),
    ...mapMutations('conversations', [
      'setCurrentStatus'
    ]),
    getTimeFromNow () {
      if (!this.status || !this.status.lastActive) { return '' }
      this.timeFromNow = moment(this.status.lastActive).fromNow()
    },
    toggleActive () {
    },
    async getUserStatus () {
      this.getStatusForUser(this.currentUser)
      this.$socket.sendObj({
        type: 'subscribe',
        event: `active:${this.currentUser.id}`
      })
    },
    gotoProfile () {
      let route = this.$router.resolve(`/jobseekers/${this.currentUser.id}`)
      window.open(route.href, '_blank')
    },
    onOpenConversations () {
      this.$emit('onOpenConversations')
    }
  },
  data () {
    return {
      dropdownActive: false,
      timeFromNow: ''
    }
  },
  mounted () {
    this.setCurrentStatus(null)
    this.getUserStatus()
    setInterval(this.getTimeFromNow, 50000)
  },
  destroyed () {
    this.setCurrentStatus(null)
    this.$socket.sendObj({
      type: 'unsubscribe',
      event: `active:${this.currentUser.id}`
    })
    clearInterval(this.getTimeFromNow)
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.topbar {
  display: flex;
  justify-content: space-between;

  a {
    color: black;
  }
}

.conversation-icon {
  position: fixed;
  top: 20px;
  left: 17px;
  z-index: 100;
}

.text-info {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  span {
    color: #888;
  }
}

.info {
  display: flex;
  flex-direction: row;
}

.user-image {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/messaging/conversation-top-bar.vue